import SanityImage from './media/SanityImage.client';
import sanityConfig from '../../sanity.config';

interface InsetImagesProps {
  component: any;
}

export function InsetImages({component}: InsetImagesProps) {
  return (
    <div className="image-panels" key={component.id}>
      {component.images?.map((image: any) => {
        return (
          <div className="panel" key={image.id}>
            <SanityImage
              dataset={sanityConfig.dataset}
              projectId={sanityConfig.projectId}
              objectFit="cover"
              layout="fill"
              src={image?.asset._ref}
            />
          </div>
        );
      })}
    </div>
  );
}
